<template>
  <div class="mt-[22px] sm:mt-[38px] relative">
    <span class="text-lg font-raleway pb-[13px] block">Enter the delivery postal code</span>
    <div class="relative">
      <div class="relative field">
        <Field
          :name="'zip' + '-' + index"
          :rules="[required]"
          class="w-full border rounded-small shadow-gray pt-4 pb-[13px] px-[18px] h-[49px] sm:h-[53px] text-[19px] sm:text-xl border-black placeholder:text-silver"
          placeholder="Delivery Postal Code"
          v-model="internalValue"
          @focus="focusField"
          @bind="focusField"
        />
        <span
          :class="isFocused ? 'opacity-100 z-[1]' : ' opacity-0 z-0'"
          class="absolute bg-white -top-2 left-4 px-1 transition-all duration-75 ease-linear text-sm"
          >Delivery Postal Code</span
        >
      </div>
      <span class="text-red-500 text-xs pt-1 block">{{ errors['zip' + '-' + index] }}</span>
      <span v-if="zipErr.length" class="text-red-500 text-xs pt-1 block">{{ zipErr }}</span>
      <IconCheck v-if="checkZip" class="absolute top-4 sm:top-5 right-[22px] w-4 sm:w-max" />
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import IconCheck from '@components/icons/IconCheck.vue'
import { Field } from 'vee-validate'
import { required } from '@utills/helpers/validation'
import {useDebounceFn} from "@vueuse/core";
import {useSignUpCartsStore} from "@stores/sign-up-cart";
export default defineComponent({
  components: { IconCheck, Field },
  props: {
    zipCode: {
      type: String,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    checkZip: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    const zipErr = ref('');
    const validateZip = (val: any) => {
      const trimmedVal = val.trim().toUpperCase();

      // US ZIP code (5 digits)
      if (/^\d{5}$/.test(trimmedVal)) {
        zipErr.value = '';
        return;
      }

      // UK postcode (e.g., SW1A 1AA, M1 1AA, B33 8TH)
      if (/^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(trimmedVal)) {
        zipErr.value = '';
        return;
      }

      // Canadian postal code (e.g., K1A 0A6, M5V 3L9)
      if (/^[A-Z]\d[A-Z]\s*\d[A-Z]\d$/i.test(trimmedVal)) {
        zipErr.value = '';
        return;
      }

      // If none match and has content, show error
      if (trimmedVal.length > 0) {
        zipErr.value = 'Please enter a valid postal code (US ZIP, UK postcode, or Canadian postal code)';
      } else {
        zipErr.value = '';
      }
    };

    const internalValue = computed({
      get: () => props.zipCode,
      set: (val) => {
        validateZip(val)
        debouncedFn(val)
      }
    })

    const isFocused = ref(false)

    const { setShipment } = useSignUpCartsStore();

    function focusField() {
      isFocused.value = true
    }

    const debouncedFn = useDebounceFn(async (val) => {
      emit('update:zipCode', val)
      emit('update:modelValue', val)
      await setShipment(val)
    }, 500)

    return {
      isFocused,
      focusField,
      required,
      internalValue,
      zipErr
    }
  }
})
</script>
